module.exports = __webpack_public_path__ + "static/media/UserDot2.39f05091.png";